import styled from 'styled-components';
import { tokens } from '@plataforma/components';
import { colors, grid } from '_/styles';

const COLORS_MATCH = {
  policyIssued: colors.baseGreen,
  canceled: colors.baseRed,
  renew: colors.baseOrange
};

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin: ${grid.large} 0;
  p {
    ${({ status }) =>
      status ? `color:${COLORS_MATCH[status]}` : 'margin-left:0;'};
  }
`;

export const Title = styled.p`
  color: ${colors.textMain};
  font-size: 16px;
  font-weight: ${tokens.font.weight.semibold};
  margin-left: ${grid.regular};
`;
